module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main"
  }, [_c('form', {
    staticClass: "form-main__form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validate($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fullName),
      expression: "fullName"
    }],
    staticClass: "form-main__input",
    class: {
      'form-main__input--error': _vm.errors.has('name')
    },
    attrs: {
      "name": "fullName",
      "validate": 'required|alpha',
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fullName = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "form-main__group__message"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|regex:^[(]?[0-9]{3}[)]?[-]?[ ]?[.]?[0-9]{3}[-]?[ ]?[.]?[0-9]{4}$'),
      expression: "'required|regex:^[(]?[0-9]{3}[)]?[-]?[ ]?[.]?[0-9]{3}[-]?[ ]?[.]?[0-9]{4}$'"
    }],
    staticClass: "form-main__input",
    class: {
      'input': true, 'form-main__input--error': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])]), _c('div', {
    staticClass: "form-main__group form-main__location"
  }, [_c('div', {
    staticClass: "form-main__title"
  }, [_vm._v("Choose a location (optional)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }],
    staticClass: "form-main__radio",
    attrs: {
      "type": "radio",
      "name": "location",
      "id": "boone",
      "value": "Boone"
    },
    domProps: {
      "checked": _vm._q(_vm.location, "Boone")
    },
    on: {
      "change": function($event) {
        _vm.location = "Boone"
      }
    }
  }), _c('label', {
    staticClass: "form-main__label",
    attrs: {
      "for": "boone"
    }
  }, [_vm._v("Boone")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.location),
      expression: "location"
    }],
    staticClass: "form-main__radio",
    attrs: {
      "type": "radio",
      "name": "location",
      "id": "northWilkesboro",
      "value": "North Wilkesboro"
    },
    domProps: {
      "checked": _vm._q(_vm.location, "North Wilkesboro")
    },
    on: {
      "change": function($event) {
        _vm.location = "North Wilkesboro"
      }
    }
  }), _c('label', {
    staticClass: "form-main__label",
    attrs: {
      "for": "northWilkesboro"
    }
  }, [_vm._v("North Wilkesboro")])]), _c('div', {
    staticClass: "form-main__group"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "form-main__textarea",
    attrs: {
      "name": "message",
      "placeholder": "How can we help you?"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-main__group"
  }, [_c('input', {
    staticClass: "btn-main form-main__submit-button",
    attrs: {
      "type": "submit"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13059a46","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/form.pug
// module id = 614
// module chunks = 1